module.exports = __webpack_public_path__ + "static/img/looking-ahead-integrated-approach-hero.c06e085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/looking-ahead-integrated-approach-hero.jpg
// module id = JoyG
// module chunks = 0